import React from "react";

const ProgressCircular = ({ value = 0, max = 100, amount = 150 }) => {
  const radius = 105; 
  const strokeWidth = 16;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.min(value / max, 1);
  const strokeDashoffset = circumference - progress * circumference;

  return (
    <div className="flex flex-col items-center justify-center relative my-6">
      <svg
        viewBox="0 0 240 240"
        className="w-[240px] h-[240px] transform -rotate-90"
      >
        <circle
          cx="120"
          cy="120"
          r={radius}
          stroke="#E5E5E5"
          strokeWidth={strokeWidth}
          fill="none"
        />

        <circle
          cx="120"
          cy="120"
          r={radius}
          stroke="#232222"
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="butt"   
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-500 ease-in-out"
        />
      </svg>

      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <p className="text-[32px] font-semibold text-[#232222] leading-none">
          ${amount.toFixed(2)}
        </p>
        <p className="text-[15px] text-[#9FA1A3] font-normal mt-1">
          Total Bill Amount
        </p>
      </div>
    </div>
  );
};

export default ProgressCircular;
